var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DForm',_vm._g({attrs:{"value":_vm.value}},_vm.$listeners),[_c('DField',_vm._b({key:"name",staticClass:"mb-6"},'DField',_vm.name,false)),_c('DField',_vm._b({key:"parent"},'DField',_vm.parent,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }